import PropTypes from 'prop-types';
import React, {Component} from 'react';
import classNames from 'classnames';
import Transition from 'react-transition-group/Transition';
import './LoadingOverlay.less';

class LoadingOverlay extends Component {
    static propTypes = {
        /** Flag for displaying LoadingOverlay.  */
        loading: PropTypes.bool,
        /** Optional event handler to fire after a LoadingOverlay has been dismissed */
        onLoadingStop: PropTypes.func,
        /** Flag for enabling transitions */
        transition: PropTypes.bool,
        /** Option Flag for enabling transitions when the component appears */
        transitionAppear: PropTypes.bool
    };

    static defaultProps = {
        transition: true,
        transitionAppear: true,
        loading: true
    };

    handleExit = () => {
        if (this.props.onLoadingStop) {
            this.props.onLoadingStop();
        }
    };

    renderOverlay = (state) => {
        if (state === 'exited') {
            return false;
        }

        const transitionStyles = {
            entered: {'in': true}
        };

        const loadingClasses = classNames(
            'LoadingOverlay',
            'fade',
            transitionStyles[state]
        );

        return (
            <div role="status" className={loadingClasses}>
                <ul aria-hidden className="LoadingOverlay__ul">
                    <li className="LoadingOverlay__li LoadingOverlay__li--1 bg-brand" />
                    <li className="LoadingOverlay__li LoadingOverlay__li--2 bg-brand" />
                    <li className="LoadingOverlay__li LoadingOverlay__li--3 bg-brand" />
                    <li className="LoadingOverlay__li LoadingOverlay__li--4 bg-brand" />
                </ul>
            </div>
        );
    };

    render() {
        const {
            loading,
            transition,
            transitionAppear
        } = this.props;

        return (
            <Transition
                appear={transitionAppear && transition}
                in={loading}
                timeout={500}
                onExited={this.handleExit}
                enter={transition}
                exit={transition}
                unmountOnExit
            >
                {(state) => this.renderOverlay(state)}
            </Transition>
        );
    }
}

export default LoadingOverlay;
